import { Box, Divider, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { useTheme } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { headerSty, contentSty } from "../table-styles";

const RoleBottom = () => {
  const isMedium = useResponsive("down", "md", "xs");
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        p: 4,
        borderRadius: "20px",
        width: isMedium ? "100%" : "85%",
        mt: 4,
      }}
    >
      <Typography
        sx={{
          color: "#64748B",
          fontFamily: "Lexend",
          fontWeight: 500,
          fontSize: 16,
          lineHeight: 1.6,
          mb: 3,
        }}
      >
        Recent Activity
      </Typography>
      <Divider sx={{ my: 3 }} />
      <BottomTable />
    </Box>
  );
};

export default RoleBottom;
function createData(device: string, time: string, action: string) {
  return { device, time, action };
}

const rows = [
  createData("Mobile", "Jan 1st, 2022, 12:55 AM", "Medic sign in"),
  createData("Mobile", "Jan 1st, 2022, 12:55 AM", "Shared a shift"),
  createData(
    "Mobile",
    "Jan 1st, 2022, 12:55 AM",
    "Accepted a job and St.m Joseph’s hospital, Jalingo."
  ),
];

const BottomTable = () => {
  const theme = useTheme();
  const headStyles = {
    ...headerSty,
    color: theme.palette.neutral.main,
    textAlign: "left",
  };
  const contentStyles = {
    ...contentSty,
    textAlign: "left",
    padding: "8px 16px",
  };
  return (
    <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ ...headStyles }}>Device</TableCell>
            <TableCell sx={{ ...headStyles }}>Time</TableCell>

            <TableCell sx={{ ...headStyles }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, id) => (
            <TableRow key={id}>
              <TableCell sx={{ ...contentStyles }}>{row.device}</TableCell>
              <TableCell sx={{ ...contentStyles }}>{row.time}</TableCell>
              <TableCell sx={{ ...contentStyles }}>{row.action}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
